module.exports = __webpack_public_path__ + "static/media/atp_sassari.9c10ea71.svg";